export const createSingletonCableStream = ({
  buildIdentifier,
  eventHandlers,
  shouldUnsubscribeOnEvent,
  onRejectedMessage,
}) => {
  let activeSubscription = null;
  let activeKey = null;
  let activeXhr = null;
  let handlers = {};
  let session = 0;

  const handleStreamData = (event) => {
    eventHandlers[event.type]?.(event, handlers);
  };

  const abortXhr = () => {
    if (!activeXhr) return;
    activeXhr.abort();
    activeXhr = null;
  };

  const trackXhr = (xhr) => {
    abortXhr();
    activeXhr = xhr;

    xhr.always?.(() => {
      if (activeXhr === xhr) activeXhr = null;
    });

    return xhr;
  };

  const unsubscribe = () => {
    session += 1;

    if (activeSubscription) {
      activeSubscription.unsubscribe();
      activeSubscription = null;
    }

    activeKey = null;
  };

  const subscribe = (key) => {
    if (!key) return;
    if (activeKey === key && activeSubscription) return;

    unsubscribe();

    const mySession = session;
    activeKey = key;

    activeSubscription = App.cable.subscriptions.create(buildIdentifier(key), {
      connected() {
        if (mySession === session) handlers.onConnected?.();
      },
      disconnected() {
        if (mySession === session) handlers.onDisconnected?.();
      },
      rejected() {
        if (mySession !== session) return;
        if (!onRejectedMessage) return;
        handlers.onError?.(onRejectedMessage);
        unsubscribe();
      },
      received(event) {
        if (mySession !== session) return;
        handleStreamData(event);
        if (shouldUnsubscribeOnEvent?.(event)) unsubscribe();
      },
    });
  };

  const setHandlers = (newHandlers) => {
    handlers = { ...handlers, ...newHandlers };
  };

  const callHandler = (name, ...args) => handlers[name]?.(...args);

  const getActiveKey = () => activeKey;

  return {
    setHandlers,
    callHandler,
    subscribe,
    unsubscribe,
    abortXhr,
    trackXhr,
    getActiveKey,
  };
};
